import useSWR from 'swr'

import { useCallMutation } from '@/common/api/client'
import { apiPostFetcher } from '@/common/api/fetcher'
import {
  CompetitorApiPath,
  GetCompetitorDetailResponse,
  GetCompetitorDetailVars,
  RunCompetitorResponse,
  RunCompetitorVars
} from '@/common/api/params/competitor'

// options.refreshInterval > 0 で自動更新（分析中のポーリング用）。
// 関数形式（最新データを受け取る）も可能で、status が analyzing の間だけポーリングする用途に使う。
export const useCompetitorDetailApi = (
  vars: GetCompetitorDetailVars | undefined,
  options?: {
    refreshInterval?: number | ((latest: GetCompetitorDetailResponse | undefined) => number)
  }
) => {
  return useSWR<
    GetCompetitorDetailResponse,
    Response,
    [string, GetCompetitorDetailVars] | undefined
  >(vars ? [CompetitorApiPath.GET_COMPETITOR_DETAIL, vars] : undefined, {
    refreshInterval: options?.refreshInterval ?? 0
  })
}

// バックグラウンド実行を起動する（レコードを作成し、即座に id/status を返す）
export const useRunCompetitorApi = (options?: {
  onSuccess?: (response: RunCompetitorResponse) => void
  onError?: (error: Response) => void
}) => {
  return useCallMutation<RunCompetitorResponse, RunCompetitorVars>(
    CompetitorApiPath.RUN_COMPETITOR,
    { ...options },
    apiPostFetcher
  )
}
